import React, { Component } from 'react';

import axios from 'axios';

import swal from 'sweetalert';

import './index.css';

import apiurl from './apiurl';





export default class Uwagi_Pop extends React.Component {

    constructor(props) {

      super(props);

      this.state = {

        errors: null, 

        token: props.token ,

        rok: props.rok ,

        idUchwaly: props.idUchwaly ,

        idWydzial: props.idWydzial ,

        nazwaw: props.nazwaw ,

        data: [],

        dataRodz: [],

        podzial: [],

        loadingdata: true,

        rozdzial: 'Brak',

        czescBudzetu: '',

        saveload: true,

        savesuccess: false,

      };

      this.getRodzaje();



      this.timer = this.timer.bind(this);



    }

    

    onChange = (z) => { 

    this.setState({ comment: z.target.value }) 

    }



    timer() {

      this.setState({ savesuccess: false, saveload: true });

    }

    

    

    getData = (rozdzial, id) => {

      axios

        .get(apiurl+"api/UwagiWniosku", 

        {params : {rok: this.state.rok, idUchwaly: this.state.idUchwaly, idWydzial: this.state.idWydzial , rozdzial : rozdzial, DWBP: this.props.dwbp, czescbudzetu: id},

        headers: { 'Authorization' : "Bearer " + this.state.token }})

        .then(response => {

          if(response.data.comment === '' || response.data.comment === null) {this.setState({ comment: '', loadingdata: false })} 

          else {this.setState({ comment: response.data.comment, loadingdata: false })}

        })

        .catch(error => { 

          swal(error.response.data);
          this.setState({ loadingdata: false })
        })

    }



    getDataPodzial = (zmienna) => {

      axios

        .get(apiurl+"api/UwagiWniosku/PodzialBudzetu", 

        {params : {rok: this.state.rok, idUchwaly: this.state.idUchwaly, idWydzial: this.state.idWydzial},

        headers: { 'Authorization' : "Bearer " + this.state.token }})

        .then(response => {

          let data = response.data;

          if(data) {

          this.setState({ podzial: data, czescBudzetu: data[0].id });

          this.getData(zmienna, data[0].id);

          } else {

            this.setState({ podzial: []});

            this.getData(zmienna, '');

          }

          

        })

        .catch(error => { 

          swal(error.response.data);

        })

    }



    getRodzaje = () => {

      axios

        .get(apiurl+"api/UwagiWniosku/Rozdzialy", 

        {params : {rok: this.state.rok, idUchwaly: this.state.idUchwaly, idWydzial: this.state.idWydzial },

        headers: { 'Authorization' : "Bearer " + this.state.token }})

        .then(response => {

          let data = response.data;

          this.setState({ dataRodz: data, loadingdata: false });
          console.log(data)

          this.getDataPodzial(data[0]);

        })

        .catch(error => { 

          swal(error.response.data);
          this.setState({ loadingdata : false })
        })

    }





    zapiszuwagi = (u) => {

      u.preventDefault();

      axios.post(apiurl+"api/UwagiWniosku",

          {rok: this.state.rok, idUchwaly: this.state.idUchwaly, idWydzial: this.state.idWydzial, comment: this.state.comment, rozdzial: this.state.rozdzial, DWBP: this.props.dwbp, czescBudzetu: this.state.czescBudzetu },

          {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })

          .then(res => {

            this.setState({ savesuccess: true, saveload: true  });

            setInterval(this.timer, 1000);

          })

      .catch(error => {

        swal(error.response.data)

        this.setState({ savesuccess: false, saveload: true })

      });

    }

    

  

render() {

const { comment, nazwaw, dataRodz, loadingdata, podzial,savesuccess, saveload } = this.state;

return (

<React.Fragment>

<div className="container">

  <h3>Uwagi</h3>

  <p>Dodaj uwagę do wniosku dla wydziału {nazwaw}</p>

    <div className="row m-2 ml-1 ">

    <div className="col-1 text-right mr-1"><span class="align-middle">Rozdział </span></div>

    <div className="col-3">

      <select type="select" class="form-control" id="rozdzial" onChange={(e) => (this.setState({ rozdzial: e.target.value }, this.getData(e.target.value, this.state.czescBudzetu)))}>

      {dataRodz.map((rozdzial, index) => {

      return (

      <option key={index} value={rozdzial}>{rozdzial}</option>

      );

      } )}

      </select> 

    </div>

    {podzial.length > 0 ? (<><div className="col-1 text-right"><span class="align-middle">Podział</span></div>

    <div className="col-3">

      <select type="select" class="form-control" id="czescBudzetu" onChange={(e) => (this.setState({ czescBudzetu: e.target.value }), this.getData(this.state.rozdzial, e.target.value))}>

      {podzial.map((data, index) => {

      const { id, text } = data;

      return (

      <option key={index} value={id}>{text}</option>

      );

      } )}

      </select> 

    </div></>) : null }

  </div>

  <hr width="75%" align="left"/>

  {loadingdata ? (<center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>) : null }

  <div class="row">

  <textarea type="text" class="form-control" rows="3" value={comment} placeholder="Wprowadź uwagi do wniosku..."  onChange={(z) => this.onChange(z)}></textarea>

  </div>

  <br />

  <div class="row">

  {savesuccess ? (<button type="button" class="btn btn-light button-text"><i class="fa fa-check"></i></button>) : (<>

  {saveload ? (

  <button  onClick={(u) => (this.setState({ saveload: false }, this.zapiszuwagi(u)))} type="button" class="btn btn-light m-3">Zapisz</button>

  ) : (<button  type="button" class="btn btn-light button-text"><div class="spinner-border spinner-border-sm" role="status"></div></button>)} </>)}

  </div>

</div>

</React.Fragment>

      );

    }

  }

